module.exports = __webpack_public_path__ + "img/ic_super_recognition.1dccf85b.png";